import React, { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  setShortage_id: any;
  source: any;
  setSource: any;
  shortage_id: any;
  handelActionOnsortes: (e: any, g: any) => void;
};

const AcceptClosingSortes: React.FC<Props> = ({
  open,
  setOpen,
  source,
  setSource,
  handelActionOnsortes,
  shortage_id,
  setShortage_id,
}) => {
  const cancelButtonRef = useRef(null);

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
            setShortage_id(null);
            setSource(null);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex justify-between items-center mt-2">
                    <h2 className="text-base font-medium">
                      Are you sure you want to {source === "accept" ? "Accept" : "Reject"} the shortage raised?
                    </h2>
                    <span
                      onClick={() => {
                        setOpen(false);
                        setShortage_id(null);
                        setSource(null);
                      }}
                    >
                      <XMarkIcon className="h-4 w-4 cursor-pointer" />
                    </span>
                  </div>
                  <div className={`bg-white py-1 rounded-lg overflow-scroll mt-4`}></div>
                  <p className="font-semibold text-red-400">{shortage_id?.shortage_reason}</p>
                  <div className="flex justify-end gap-4 mt-4">
                    <button
                      type="submit"
                      onClick={() => {
                        setOpen(false);
                        setShortage_id(null);
                        setSource(null);
                      }}
                      className="rounded-md bg-[#72767f1a] px-4 py-2 text-xs text-[#000000] font-medium"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="rounded-md bg-[#193A6A] font-bold px-4 py-2 text-xs text-white"
                      onClick={() => {
                        handelActionOnsortes(source, shortage_id?.shortage_request_id);
                        setShortage_id(null);
                        setSource(null);
                        setOpen(false);
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default AcceptClosingSortes;
